<div class="tracking-page-coupon-widget-container">
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Coupon codes</pdq-heading>
        <div class="sub-header">
          Customers will see the first coupon that matches. Order them by priority.
          <img
            src="assets/icons/icon-info.svg"
            class="form-title-info-icon"
            matTooltip="Example setup:&#10;
            :: Coupon A - 30% off for late customers.
            :: Coupon B - 10% off for first timers.&#10;
            If a customer is both late and a first timer, they will see Coupon A because it's higher in priority."
            matTooltipClass="pdq-mat-tooltip" />
        </div>
      </div>
      <pdq-divider></pdq-divider>
      <div
        class="droplist"
        [cdkDropListData]="couponCodesFormArray.value"
        cdkDropList
        (cdkDropListDropped)="drop($event)">
        @for (couponCodesFormGroup of couponCodesFormArray?.controls; track couponCodesFormGroup; let i = $index) {
          <div [cdkDragData]="couponCodesFormGroup.value" cdkDrag>
            <form [formGroup]="couponCodesFormGroup | asFormGroup">
              <pdq-collapsed>
                <div class="collapsed-wrapper">
                  <pdq-collapsed-header arrowColor="var(--on-surface-light)">
                    <div class="collapsed-header-wrapper">
                      <div class="collapsed-header-title">
                        <div cdkDragHandle class="drag-wrapper">
                          @for (i of [0, 1, 2, 3, 4, 5, 6, 7]; track $index) {
                            <div class="drag-rectangle"></div>
                          }
                        </div>
                        {{
                          couponCodesFormGroup.value.internalName
                            ? 'Coupon - ' + couponCodesFormGroup.value.internalName
                            : 'New coupon'
                        }}
                      </div>
                      <div class="collapsed-header-actions">
                        <pdq-button
                          [style.color]="'var(--on-surface-light)'"
                          variant="ghost"
                          icon="delete"
                          (onClick)="removeCouponCode(i)">
                        </pdq-button>
                        <pdq-button
                          [style.color]="'var(--on-surface-light)'"
                          [active]="couponPreviewIndex === i"
                          variant="secondary"
                          size="small"
                          label="Preview"
                          secondaryIcon="side_right_arrow"
                          (onClick)="previewCouponCode($event, i)">
                        </pdq-button>
                      </div>
                    </div>
                  </pdq-collapsed-header>
                  <pdq-collapsed-content>
                    <div class="content">
                      <pdq-input
                        label="Internal name"
                        formControlName="internalName"
                        placeholder="Offer 10% on late order for first timers">
                      </pdq-input>
                      <pdq-rules-dynamic-form
                        [formGroup]="couponCodesFormGroup | asFormGroup"
                        label="Offer coupon to orders that meet the following rules:"
                        [formArrayFieldName]="formArrayFieldName"
                        [rules]="trackingPageCouponCodeRules"
                        [entities]="entities"
                        [versionWithOrOperator]="true"></pdq-rules-dynamic-form>
                      <pdq-input
                        label="Title"
                        formControlName="title"
                        placeholder="Oops! your order is late, here's a 10% off coupon code">
                      </pdq-input>
                      <pdq-input
                        label="Display text"
                        formControlName="description"
                        placeholder="Here’s a 10% coupon code as a thank you for your patience"
                        [invalid]="couponCodesFormGroup.get('description').hasError('required')"
                        [invalidMsg]="'Required'"></pdq-input>
                      <div class="coupon-type-wrapper">
                        <pdq-dropdown
                          formControlName="type"
                          title="Coupon type"
                          style="width: 100%"
                          [options]="couponTypeOptions"
                          [defaultOption]="couponTypeOptions[0]"
                          [invalid]="couponCodesFormGroup.get('type').hasError('required')"
                          [invalidMsg]="'Required'"></pdq-dropdown>
                        <pdq-input-arrows
                          formControlName="value"
                          label="Coupon value"
                          widthSize="auto"
                          [symbol]="
                            couponCodesFormGroup.get('type').value === 'percentage'
                              ? '%'
                              : (shop?.metadata?.currency | currencySign)
                          "
                          [invalid]="couponCodesFormGroup.get('value').hasError('required')"
                          [invalidMsg]="'Required'"></pdq-input-arrows>
                      </div>
                      <div class="expiration-time-wrapper">
                        <pdq-input-arrows
                          formControlName="expiresInDays"
                          label="Expires in (days)"
                          widthSize="auto"
                          [required]="false"></pdq-input-arrows>
                        <span>Leave blank for no expiration time</span>
                      </div>
                      <div>
                        <label style="font-size: 14px">Combines with</label>
                        <pdq-checkbox
                          formControlName="combinesWithProductDiscounts"
                          label="Product discounts"
                          labelSize="small"></pdq-checkbox>
                        <pdq-checkbox
                          formControlName="combinesWithOrderDiscounts"
                          label="Order discounts"
                          labelSize="small"></pdq-checkbox>
                        <pdq-checkbox
                          formControlName="combinesWithShippingDiscounts"
                          label="Shipping discounts"
                          labelSize="small"></pdq-checkbox>
                      </div>
                    </div>
                  </pdq-collapsed-content>
                </div>
              </pdq-collapsed>
            </form>
          </div>
        }
      </div>
      <footer>
        <pdq-button variant="ghost-light" (click)="addCouponCode()">+ Add coupon code</pdq-button>
      </footer>
    </div>
  </pdq-card>
</div>
